module.exports = __webpack_public_path__ + "bg.58be8fc9.png";